module.exports = __webpack_public_path__ + "static/media/4ODA9.48ed4353.jpg";